import { Trans } from '@lingui/macro';
import {
    HYPERVISOR_ADMIN_LIST_DATA_TABLE_ID,
    HYPERVISOR_ADMIN_LIST_EMPTY_STATE_MESSAGE,
    HYPERVISOR_LIST_DATA_SOURCE,
} from '../InfrastructureConstants';
import InfrastructureListSelector from './InfrastructureListSelector';
import { useInfrastructureListConfig } from '../InfrastructureListSelectorUtils';

const DEFAULT_EMPTY_MESSAGE = 'No hypervisors available';
const FALLBACK_TABLE_ID = 'hypervisor-list-fallback';

/**
 * Displays a list of hypervisors for a vCenter with enable/disable actions
 * Wraps InfrastructureListSelector with hypervisor-specific configuration
 */
const HypervisorListSelector = () => {
    const { url, tableId, emptyMessage } = useInfrastructureListConfig({
        dataSource: HYPERVISOR_LIST_DATA_SOURCE,
        tableId: HYPERVISOR_ADMIN_LIST_DATA_TABLE_ID,
        emptyMessage: HYPERVISOR_ADMIN_LIST_EMPTY_STATE_MESSAGE,
        fallbackTableId: FALLBACK_TABLE_ID,
        defaultEmptyMessage: DEFAULT_EMPTY_MESSAGE,
    });

    return (
        <InfrastructureListSelector
            tableId={tableId}
            url={url}
            emptyStateMessage={emptyMessage}
            title={<Trans>Hypervisors</Trans>}
        />
    );
};

export default HypervisorListSelector;
